export default __webpack_public_path__ + "static/media/Toggle-inactive.a8774705.svg";